import React from 'react';
import _ from 'lodash-es';
import { WidgetProps } from '@rjsf/core';
import { OutlinedTextWidget } from 'components/form-elements/JsonForms/components/Text';
import { getDotSeparatedId } from 'components/form-elements/JsonForms/utils';

/**
 * Widget for the `installationOther` text field.
 *
 * The field is always visible. Its label adapts to the selected
 * installation type:
 *  - "Other" (or nothing selected) -> "Other installation type"
 *    (the default `relining.installationOther` label)
 *  - Liner / Spray / Branch -> "Additional subtitle", acting as an
 *    additional subtitle for the chosen installation type.
 */
export function InstallationOtherWidget(props: WidgetProps) {
  const formData = props.formContext?.formData;

  // e.g. "root_relinings_0_installationOther" -> "relinings.0.installationOther"
  const fieldPath = getDotSeparatedId(props.id);
  const installationPath = fieldPath.replace(/installationOther$/, 'installation');
  const installation = _.get(formData, installationPath);

  // Treat "nothing selected yet" as the default "Other installation type"
  // label, but only mark the field as required once "Other" is chosen.
  const isOther = !installation || installation === 'other';
  const isRequired = installation === 'other';

  if (isOther) {
    return <OutlinedTextWidget {...props} required={isRequired} />;
  }

  return (
    <OutlinedTextWidget
      {...props}
      required={false}
      uiSchema={{ ...props.uiSchema, 'ui:title': 'relining.installationSubtitle' }}
    />
  );
}
